// extracted by css-extract-rspack-plugin
export default {"table_link":"table_link___xOF7u"};